// extracted by mini-css-extract-plugin
export default {"closeModalButton":"DisablePopup_closeModalButton__am0Jz","modalTitle":"DisablePopup_modalTitle__8IExs","buttonSection":"DisablePopup_buttonSection__PxnST"};